/* BRAINGAIN EU Axe BFCM v1.0. Uses original Axe inputs and cart handlers.
   Offer IDs are deliberately not hardcoded: products are identified by the
   server-rendered configuration and Axe's product metadata. */
(() => {
  'use strict';
  if (window.BGAxeEU) return;
  const instances = new Map();
  let serial = 0;
  const copy = {
  en: {lead:'Complete your setup',tail:'with these deals:',pill:'BEST VALUE',deal:'Heavy Duty Rack + Adjustable Bench',more:'More information about',swap:(amount)=>`Swapped to the Rack + Bench deal, ${amount} cheaper.`},
de: {lead:'Vervollständige dein Setup',tail:'mit diesen Angeboten:',pill:'BESTES PREIS-LEISTUNGS-VERHÄLTNIS',more:'Mehr Informationen zu',swap:(amount)=>`Zum Rack + Bank-Angebot gewechselt – ${amount} günstiger.`},
fr: {lead:'Complète ton équipement',tail:'avec ces offres :',pill:'MEILLEUR RAPPORT QUALITÉ-PRIX',more:"Plus d’informations sur",swap:(amount)=>`Offre support + banc sélectionnée : ${amount} de moins.`},
es: {lead:'Completa tu equipo',tail:'con estas ofertas:',pill:'MEJOR RELACIÓN CALIDAD-PRECIO',more:'Más información sobre',swap:(amount)=>`Hemos seleccionado la oferta de soporte + banco: ahorras ${amount}.`},
it: {lead:'Completa il tuo setup',tail:'con queste offerte:',pill:'MIGLIOR RAPPORTO QUALITÀ-PREZZO',more:'Maggiori informazioni su',swap:(amount)=>`Abbiamo selezionato l’offerta supporto + panca: risparmi ${amount}.`}
  };
  const clean = value => (value || '').replace(/\s+/g,' ').trim();
  function parseMoney(text) {
    let value = clean(text).replace(/[^\d.,-]/g,'');
    if (!value) return null;
    const comma=value.lastIndexOf(','), dot=value.lastIndexOf('.');
    if (comma > dot) value=value.replace(/\./g,'').replace(',','.');
    else value=value.replace(/,/g,'');
    const number=Number(value);
    return Number.isFinite(number) ? Math.round(number*100) : null;
  }
  const node = (tag,cls,text) => {
    const out=document.createElement(tag); if(cls) out.className=cls;
    if(text !== undefined) out.textContent=text; return out;
  };
  const setText=(element,text)=>{if(element.textContent!==text) element.textContent=text;};
  function getData(list) {
    const data=new Map();
    list.querySelectorAll('.axe-debug-info').forEach(element=>{
      try {
        const variant=JSON.parse(element.textContent);
        data.set(String(variant.id),{...variant,handle:element.dataset.axeUpsellProduct,
          available:variant.available!==false && element.dataset.axeIsAvailable!=='false'});
      } catch (_) {}
    });
    return data;
  }
  function source(row,data) {
    const original=row.querySelector('.state'); if(!original) return null;
    const title=clean(original.querySelector('.axe-display-message')?.textContent)
      .replace(/^\+\s*/,'').replace(/^(?:Add|Ajouter|Ajoute|Añadir|Añade|Agregar|Agrega|Hinzufügen)\s+/i,'');
    const info=original.querySelector('.axe-inline-info') || original.querySelector('[id^="axe-popup-"]:not([id^="axe-popup-icon-"]):not([id^="axe-popup-overlay-"])');
    const bullets=Array.from(info?.querySelectorAll('p,li')||[]).filter(p=>!p.querySelector('p,li'))
      .map(p=>clean(p.textContent)).filter(Boolean).slice(0,3);
    const price=parseMoney(original.querySelector('.axe-price')?.textContent) ?? data?.price;
    const was=parseMoney(original.querySelector('.axe-compare-at-price')?.textContent) ?? data?.compare_at_price;
    const image=original.querySelector('.axe-main-image');
    if(!title || !Number.isFinite(price)) return null;
    return {title,bullets,price,was,image:image?.getAttribute('src')||'',alt:image?.alt||title};
  }
  function roleFor(input,data,config) {
    return Object.keys(config.accessories).find(role=>{
      const accessory=config.accessories[role];
      return (accessory.id && input.dataset.upsellId===accessory.id) || data?.handle===accessory.handle;
    });
  }
  function setChecked(card,value,current) {
    if(!card || card.input.checked===value) return;
    card.input.checked=value;
    if(card.input!==current) card.input.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function createCard(row,input,role,source,state) {
    const key='bg-eu-axe-'+(++serial);
    const body=node('div','bg-axe-card-body'),media=node('div','bg-axe-media');
    const title=node('span','bg-axe-title',source.title);title.id=key+'-title';
    const prices=node('div','bg-axe-price-line'),price=node('span','bg-axe-price'),was=node('s','bg-axe-was');
    const question=node('button','bg-axe-question','?');question.type='button';
    const info=node('div','bg-axe-info');info.id=key+'-info';info.hidden=true;
    question.setAttribute('aria-controls',info.id);question.setAttribute('aria-expanded','false');
    input.setAttribute('aria-labelledby',title.id);
    prices.append(price,was,question);body.append(media,title,prices);row.append(body,info);
    row.dataset.bgRole=role;
    if(role==='deal')row.append(node('span','bg-axe-pill',state.copy.pill));
    return {row,input,role,source,body,media,title,price,was,question,info};
  }
  function render(card,state) {
    const cards=state.cards;
    const combined=card.role==='deal' && cards.rack && cards.bench;
    const title=combined ? (state.copy.deal||cards.rack.source.title+' + '+cards.bench.source.title) : card.source.title;
    setText(card.title,title);setText(card.price,state.money(card.source.price));
    const was=combined && Number.isFinite(cards.rack.source.was) && Number.isFinite(cards.bench.source.was)
      ? cards.rack.source.was+cards.bench.source.was : card.source.was;
    setText(card.was,Number.isFinite(was)&&was>card.source.price?state.money(was):'');card.was.hidden=!card.was.textContent;
    card.question.setAttribute('aria-label',state.copy.more+' '+title);
    const images=combined?[cards.rack.source,cards.bench.source]:[card.source];
    const signature=JSON.stringify(images.map(s=>[s.image,s.alt]));
    if(signature!==card.imageSignature){
      card.imageSignature=signature;card.media.replaceChildren();
      images.forEach(source=>{
        if(!source.image)return;
        try {
          const url=new URL(source.image,location.href);if(!['https:','http:'].includes(url.protocol))return;
          url.searchParams.set('width','240');const img=node('img');img.src=url.href;img.alt=source.alt;
          img.width=120;img.height=100;img.loading='lazy';card.media.append(img);
        } catch(_) {}
      });
    }
    const groups=combined?['rack','bench'].map(role=>({heading:cards[role].source.title,bullets:cards[role].source.bullets})):[{bullets:card.source.bullets}];
    const infoSignature=JSON.stringify(groups);
    if(infoSignature!==card.infoSignature){
      card.infoSignature=infoSignature;card.info.replaceChildren();
      groups.forEach(group=>{
        if(group.heading)card.info.append(node('p','bg-axe-info-heading',group.heading));
        group.bullets.forEach(text=>card.info.append(node('p','',text)));
      });
      card.question.hidden=!groups.some(group=>group.bullets.length);
    }
  }
  function normalise(state,current) {
    if(state.lock)return;state.lock=true;
    try {
      const {deal,rack,bench}=state.cards;
      const changed=Object.values(state.cards).find(card=>card.input===current);
      if(changed)state.swapped=false;
      if(changed&&changed.role!=='deal'&&changed.input.checked)setChecked(deal,false,current);
      if(deal?.input.checked&&!deal.unavailable){setChecked(rack,false,current);setChecked(bench,false,current);}
      else if(deal&&!deal.unavailable&&rack?.input.checked&&bench?.input.checked&&rack.source.price+bench.source.price>deal.source.price){
        setChecked(rack,false,current);setChecked(bench,false,current);setChecked(deal,true,current);state.swapped=true;
      }
      const selected=!!deal?.input.checked;
      [rack,bench].filter(Boolean).forEach(card=>card.row.classList.toggle('bg-axe-muted',selected));
      const saving=deal&&rack&&bench?rack.source.price+bench.source.price-deal.source.price:0;
      state.note.hidden=!(state.swapped&&selected&&saving>0);
      if(!state.note.hidden)setText(state.note,state.copy.swap(state.money(saving)));
    } finally {state.lock=false;}
    state.owner.updateATC();
  }
  function refresh(state) {
    const data=getData(state.list), seen=new Set();
    const currentCards={};
    state.list.querySelectorAll('.axe-main').forEach(row=>{
      const input=row.querySelector('.axe-input');if(!input)return;
      const variant=data.get(input.value),role=roleFor(input,variant,state.owner.config);
      const allowed=role && (state.owner.config.mode==='pro'||role==='bench') && !seen.has(role);
      if(!allowed){row.setAttribute('data-bg-excluded','');setChecked({input},false);return;}
      const details=source(row,variant);if(!details)return;
      seen.add(role);row.removeAttribute('data-bg-excluded');
      let card=state.cards[role];
      if(!card||card.row!==row)card=createCard(row,input,role,details,state);
      card.source=details;card.unavailable=variant?.available===false||input.disabled;
      currentCards[role]=card;
    });
    state.cards=currentCards;
    const {deal,rack,bench}=state.cards;
    if(deal)deal.unavailable ||= !rack||!bench||rack.unavailable||bench.unavailable;
    for(const card of Object.values(state.cards)){
      card.row.toggleAttribute('data-bg-unavailable',!!card.unavailable);
      if(card.unavailable)setChecked(card,false);
      render(card,state);
    }
    state.lead.hidden=!Object.values(state.cards).some(card=>!card.unavailable);
    normalise(state,null);
  }
  function initList(list,owner) {
    const state={list,owner,cards:{},copy:owner.copy,money:owner.money,lock:false,swapped:false};
    state.lead=node('p','bg-axe-lead');state.lead.append(node('strong','',state.copy.lead),document.createTextNode(' '+state.copy.tail));
    state.note=node('p','bg-axe-swap');state.note.hidden=true;state.note.setAttribute('role','status');state.note.setAttribute('aria-live','polite');
    list.prepend(state.lead);list.append(state.note);list.classList.add('bg-axe-ui');list.dataset.bgEuMode=owner.config.mode;
    list.addEventListener('click',event=>{
      const card=Object.values(state.cards).find(card=>card.row.contains(event.target));if(!card)return;
      if(card.question.contains(event.target)){
        event.preventDefault();event.stopImmediatePropagation();card.info.hidden=!card.info.hidden;
        card.question.setAttribute('aria-expanded',String(!card.info.hidden));
      } else if(card.body.contains(event.target)||event.target===card.row){
        event.preventDefault();event.stopPropagation();if(!card.unavailable)card.input.click();
      }
    },true);
    list.addEventListener('change',event=>{if(event.target.matches('.axe-input'))normalise(state,event.target);},true);
    return state;
  }
  function init(configNode) {
    if(instances.has(configNode))return;
    let config;try{config=JSON.parse(configNode.textContent);}catch(_){return;}
    const form=document.getElementById(config.formId);if(!form)return;
    const section=form.closest('.js-product')||document.getElementById('shopify-section-'+config.sectionId);
    if(!section)return;
    const lang=config.locale.split('-')[0];if(!copy[lang])return;
    const numberLocale=lang==='en'?'en-IE':({de:'de-DE',fr:'fr-FR',es:'es-ES'})[lang];
    const owner={config,section,form,copy:copy[lang],lists:new Map(),scheduled:false,
      money:cents=>new Intl.NumberFormat(numberLocale,{style:'currency',currency:config.currency||'EUR'}).format(cents/100)};
    owner.totalExtras=()=>{
      const state=Array.from(owner.lists.values()).find(state=>state.list.isConnected&&state.list.getClientRects().length);
      return state?Object.values(state.cards).reduce((sum,card)=>sum+(card.input.checked&&!card.unavailable?card.source.price:0),0):0;
    };
   owner.updateATC = () => {
  const id = form.querySelector('[name="id"]')?.value || config.initialVariantId;
  const price = config.variants[id];
  if (!Number.isFinite(price)) return;

  const quantity = Math.max(
    1,
    parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1
  );

  const total = owner.money(price * quantity + owner.totalExtras());

  section.querySelectorAll(
    '.product-price .price__default .price__current'
  ).forEach(element => setText(element, total));

  const button = form.querySelector('button[name="add"]');
  if (
    !button ||
    button.disabled ||
    button.getAttribute('aria-busy') === 'true' ||
    button.getAttribute('aria-disabled') === 'true' ||
    button.classList.contains('is-loading')
  ) return;

  const title = button.dataset.addToCartBase || button.dataset.addToCartText;
  if (title) setText(button, title + ' \u2022 ' + total);
};
    owner.scan=()=>{
      owner.scheduled=false;
      for(const [list]of owner.lists)if(!list.isConnected)owner.lists.delete(list);
      section.querySelectorAll('.axe-checkbox-upsell-list').forEach(list=>{
        if(!owner.lists.has(list))owner.lists.set(list,initList(list,owner));
        refresh(owner.lists.get(list));
      });
      owner.updateATC();
    };
    owner.schedule=()=>{if(!owner.scheduled){owner.scheduled=true;requestAnimationFrame(owner.scan);}};
    owner.observer=new MutationObserver(records=>{
      const sourceChanged=records.some(record=>{
        const target=record.target.nodeType===1?record.target:record.target.parentElement;
        if(target?.closest('.bg-axe-card-body,.bg-axe-info,.bg-axe-lead,.bg-axe-pill,.bg-axe-swap'))return false;
        if(record.type==='attributes')return target?.matches('.axe-input,.axe-debug-info');
        return target?.closest('.state,.axe-debug-info')||Array.from(record.addedNodes).some(n=>n.nodeType===1&&(n.matches('.axe-main,.axe-checkbox-upsell-list')||n.querySelector('.axe-checkbox-upsell-list')));
      });
      if(sourceChanged)owner.schedule();
      owner.updateATC();
    });
    owner.observer.observe(section,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','value','aria-busy','aria-disabled','class','data-axe-is-available']});
    form.addEventListener('change',owner.updateATC);form.addEventListener('input',owner.updateATC);
    section.addEventListener('on:variant:change',owner.updateATC);
    instances.set(configNode,owner);owner.scan();
  }
  function scan(){document.querySelectorAll('[data-bg-axe-eu-config]').forEach(init);}
  window.BGAxeEU={version:'1.0',parseMoney};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',event=>{
    for(const [configNode,owner]of instances)if(event.target.contains(owner.form)){owner.observer.disconnect();instances.delete(configNode);}
  });
})();
